import apiClient from '../utils/apiClient';

class ProjectService {
    static async saveProject(projectData, title, isNew = false) {
        const formData = new FormData();
        const sb3Blob = new Blob([projectData], { type: 'application/x.scratch.sb3' });
        formData.append('sb3File', sb3Blob, `${title}.sb3`);
        formData.append('title', title);
        formData.append('user_id', localStorage.getItem('userId'))
        
        const token = localStorage.getItem('accessToken');
        const endpoint = isNew ? '/projects/create' : `/projects/${localStorage.getItem('currentProjectId')}/update`;
        const method = isNew ? 'post' : 'put';

        try {
            const response = await apiClient[method](endpoint, formData);

            if (isNew) {
                localStorage.setItem('currentProjectId', response.data.id);
            }

            return response.data;
        } catch (error) {
            console.error('Project save error:', error);
            throw error;
        }
    }

    static async loadProject(projectId) {
        const token = localStorage.getItem('accessToken');
        try {
            const response = await apiClient.get(`/projects/${projectId}/load`, {
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/x.scratch.sb3'
                },
                responseType: 'arraybuffer'
            });
            return response.data;
        } catch (error) {
            console.error('Project load error:', error);
            throw error;
        }
    }

    static async checkProjectTitle(title, currentProjectId = null) {
        try {
            const token = localStorage.getItem('accessToken');
            const userId = localStorage.getItem('userId');

            if (!token || !userId) {
                return {
                    isAvailable: false,
                    message: 'Please login to check title availability'
                };
            }

            const response = await apiClient.get('/api/projects/check-title', {
                params: {
                    title,
                    currentProjectId,
                    userId
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            return {
                isAvailable: response.data.isAvailable,
                message: response.data.message,
                existingProjects: response.data.existingProjects // Add this to get list of matching titles
            };
        } catch (error) {
            console.error('Title check error:', error);
            throw error;
        }
    }

    static async createNewProject() {
        const token = localStorage.getItem('accessToken');
        try {
            const response = await apiClient.post('/projects/new', null, {
                headers: { Authorization: `Bearer ${token}` }
            });
            localStorage.setItem('currentProjectId', response.data.id);
            return response.data;
        } catch (error) {
            console.error('New project creation error:', error);
            throw error;
        }
    }

    static async getThumbnail(projectId) {
        const token = localStorage.getItem('accessToken');
        try {
            const response = await apiClient.get(`/projects/${projectId}/thumbnail`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob'
            });
            return URL.createObjectURL(response.data);
        } catch (error) {
            console.error('Thumbnail fetch error:', error);
            throw error;
        }
    }

    static async getUserProjectTitles() {
        try {
            const token = localStorage.getItem('accessToken');
            const userId = localStorage.getItem('userId');

            if (!token || !userId) {
                throw new Error('User not authenticated');
            }

            const response = await apiClient.get('/api/projects/user-projects', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            // Extract just the titles from projects
            return response.data.projects.map(project => ({
                id: project._id,
                title: project.title
            }));
        } catch (error) {
            console.error('Error fetching project titles:', error);
            throw error;
        }
    }
}

export default ProjectService;